jQuery(function ($) {
  const $logo = $('.logo');
  // na prvem screenu je logo absolute
  $logo.addClass('absolute');

  // ——— screens ———
  $('.game-first-screen .btn-primary').on('click', function (e) {
    e.preventDefault();
    $('.game-first-screen').fadeOut(400, function () {
      $('.game-second-screen').fadeIn(400, function () {
        // na drugem screenu odstrani absolute
        $logo.removeClass('absolute');
      });
    });
  });

  $('.game-second-screen .btn-primary').on('click', function (e) {
    e.preventDefault();
    $('.game-second-screen').fadeOut(400, function () {
      const $third = $('.game-third-screen');
      $third.fadeIn(400, function () {
        $third.addClass('is-active').trigger('third:active');
      });
    });
  });

  // 🔹 helper: ob vstopu na final
  function onFinalEnter() {
    const $final = $('.game-final-screen');

    // na final screenu logo postane relative
    $logo.removeClass('absolute').addClass('relative');
    $(window).off('resize.logoFix');      // resize ni več potreben
    $final.addClass('is-active').trigger('final:active');
  }

  $('.game-third-screen .btn-primary').on('click', function (e) {
    if ($(this).hasClass('disabled')) { e.preventDefault(); return; }
    e.preventDefault();
    $('.game-third-screen').fadeOut(400, function () {
      const $final = $('.game-final-screen');
      $final.fadeIn(400, function () {
        onFinalEnter();
        showTopResult();
      });
    });
  });

  // ——— Caldera ———
  let $cfWrap  = $('#caldera_form_1');
  let $cfForm  = $cfWrap.is('form') ? $cfWrap : $cfWrap.find('form').first();
  let $cfTime  = $cfWrap.find('input[name="fld_4837422"]');
  let $cfMoves = $cfWrap.find('input[name="fld_3510757"]');

  // ——— timer ———
  let tInt = null, tSec = 0;
  const $panelTime  = $('.game-third-screen .time .bordered');
  const $panelMoves = $('.game-third-screen .moves .bordered');
  const $resTime    = $('.results .time .bordered');
  const $resMoves   = $('.results .moves .bordered');

  function startTimer() {
    clearInterval(tInt);
    tSec = 0;
    $panelTime.text('00:00');
    tInt = setInterval(function () {
      tSec++;
      const mm = String(Math.floor(tSec / 60)).padStart(2,'0');
      const ss = String(tSec % 60).padStart(2,'0');
      $panelTime.text(mm + ':' + ss);
    }, 1000);
  }

  function formatCurrentTime() {
    const mm = String(Math.floor(tSec / 60)).padStart(2,'0');
    const ss = String(tSec % 60).padStart(2,'0');
    return mm + ':' + ss;
  }

  function applyResultsAndGo(finalTime, finalMoves) {
    clearInterval(tInt);
    $resTime.text(finalTime);
    $resMoves.text(finalMoves);
    if ($cfTime.length)  $cfTime.val(finalTime);
    if ($cfMoves.length) $cfMoves.val(String(finalMoves));

    $('.game-third-screen').fadeOut(400, function () {
      const $final = $('.game-final-screen');
      $final.fadeIn(400, function () {
        onFinalEnter();
        showTopResult();
      });
    });
  }

  // PRESKOČI
  let skipped = false;

  $('.game-third-screen .game-content--bottom .btn-skip').on('click', function (e) {
    e.preventDefault();

    skipped = true; // označi preskok

    const finalTime  = formatCurrentTime();
    const finalMoves = Number($panelMoves.text().trim() || '0');

    applyResultsAndGo(finalTime, finalMoves);
  });


  // ——— game ———
  const $game = $('.game-third-screen .game');
  if (!$game.length) return;

  const $finish = $('.game-third-screen .game-content--bottom .btn-primary');
  function lockFinish(lock) {
    if (lock) $finish.addClass('disabled').attr({'aria-disabled':'true','tabindex':'-1'});
    else $finish.removeClass('disabled').removeAttr('aria-disabled tabindex');
  }

  $finish.on('click', function (e) {
    if ($(this).hasClass('disabled')) { e.preventDefault(); return; }
  });

  const base    = String($game.data('base') || '').replace(/\/?$/, '/');
  const pool    = ($game.data('cards') || []);
  const backSrc = String($game.data('back') || '');

  function buildPairs() {
    const n = Math.min(10, pool.length);
    const ids = Array.from({length:n}, (_,i)=>i);
    const doubled = ids.concat(ids);
    for (let i = doubled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [doubled[i], doubled[j]] = [doubled[j], doubled[i]];
    }
    return doubled;
  }

  function renderCards(pairs) {
    $game.find('.card').each(function (i) {
      const id  = pairs[i];
      const src = base + pool[id];
      const $inner = $('<div class="card__inner" />');
      const $back  = $('<div class="card__face card__face--back" />')
                      .append($('<img alt="Karta - back">').attr('src', backSrc));
      const $front = $('<div class="card__face card__face--front" />')
                      .append($('<img alt="Karta - front">').attr('src', src));

      $(this)
        .removeData('id')
        .data('id', id)
        .attr('data-id', id)
        .removeClass('flipped matched matched-out gone')
        .empty()
        .append($inner.append($back, $front));
    });
  }

  function bindThirdStartOnce() {
    $('.game-third-screen').off('third:active.reset')
      .one('third:active', function () {
        lockFinish(true);
        $panelMoves.text('0'); $panelTime.text('00:00');
        $resMoves.text('0');   $resTime.text('00:00');
        if ($cfTime.length)  $cfTime.val('');
        if ($cfMoves.length) $cfMoves.val('');
        startTimer();
      });
  }

  renderCards(buildPairs());
  bindThirdStartOnce();

  let first = null, lock = false, clicks = 0, moves = 0;
  const $moves = $panelMoves;

  function flipToFront($c){ $c.addClass('flipped'); }
  function flipToBack($c){ $c.removeClass('flipped'); }

  $game.on('click', '.card', function () {
    if (lock) return;
    const $card = $(this);
    if ($card.hasClass('flipped') || $card.hasClass('matched') || $card.hasClass('gone')) return;

    flipToFront($card);
    clicks++;
    if (!first) { first = $card; return; }

    if (clicks % 2 === 0) { moves++; $moves.text(moves); }

    // ——— MATCH LOGIKA: skrij .card z opacity in nato auto-prehod po 2s ———
    if (Number($card.data('id')) === Number(first.data('id'))) {
      const $pair = $card.add(first);
      first = null;
      lock = true;

      $pair.addClass('matched').css({ pointerEvents:'none' });

      setTimeout(function () {
        $pair.animate({ opacity: 0 }, 400, 'swing', function () {
          $(this).addClass('gone').attr('aria-hidden','true');
          // če ni več vidnih kart → po 2s samodejno na final
          if ($game.find('.card:not(.gone)').length === 0) {
            const finalTime = formatCurrentTime();
            setTimeout(function(){
              applyResultsAndGo(finalTime, moves);
            }, 1000); // ⏳ počakaj še ~2s
          } else {
            // še ni konec → odkleneš interakcijo
            lock = false;
          }
        });
      }, 600); // počakaj po flipu
    } else {
      lock = true;
      setTimeout(function(){ flipToBack($card); flipToBack(first); first = null; lock = false; }, 800);
    }
  });

  if ($cfForm.length) {
    $cfForm.on('submit', function () {
      const t = $resTime.text().trim();
      const m = $resMoves.text().trim();
      if ($cfTime.length && t)  $cfTime.val(t);
      if ($cfMoves.length && m) $cfMoves.val(m);
    });
  }

  // ——— BACK ———
  $('.game-final-screen .back').on('click', function (e) {
    e.preventDefault();
    $('.logo').removeClass('relative');   // vedno odstrani
    const home = $('.game-final-screen').data('home') || '/';
    window.location.href = home;
  });

  // ——— Top result ———
  function showTopResult() {
    if (skipped) return;
    const $final = $('.game-final-screen');
    let $top = $final.find('.top-result');
    if (!$top.length) {
      $top = $('<div class="top-result mt-20" />').insertAfter($final.find('.results'));
    }
    const percentages = [1, 3, 5, 10, 15, 20, 25, 30];
    const today = new Date().toISOString().split('T')[0];
    const cacheKey = 'game_top_result_' + today;

    let cached = localStorage.getItem(cacheKey);
    if (!cached) {
      const randomPercent = percentages[Math.floor(Math.random() * percentages.length)];
      cached = randomPercent;
      localStorage.setItem(cacheKey, cached);
    }
    $top.html(`Danes si med top <strong>${cached}%</strong> najboljših rezultatov!`);
  }
});
